<template>
	<div class="PageTest">
		<div class="row">
			<div class="col-xs-12">



			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PageTest',
	components: {
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/PageTest.vue